import React, { useEffect } from 'react'
import { List, Filter, useListRepository, useFilter } from 'elentari'
import { Field } from 'react-final-form'
import Grid from '@material-ui/core/Grid'
import UsuariosRepository from './UsuariosRepository'
import { useAbility } from '.'
import { getListActions } from '../../lib/crudAuthorization'
import { Usuario, CustomAutocomplete } from '../../components'
import CentroCustoAutocomplete from '../CentrosCusto/CentroCustoAutocomplete'
import UnidadeNegocioAutocomplete from '../UnidadeNegocio/UnidadeNegocioAutocomplete'
import moment from 'moment'
import { useHistory } from 'react-router-dom'

export const REALMS = [
  { label: 'Administrador', value: 'admin' },
  { label: 'Gestor', value: 'gestor' },
  { label: 'Embarcador', value: 'embarcador' },
  { label: 'Analista Auxiliar de GR', value: 'analista' },
  { label: 'Analista Assistente de GR', value: 'analista_2' },
  { label: 'Analista Auxiliar de Monitoramento', value: 'analista_op' },
  { label: 'Analista Assistente de Monitoramento', value: 'analista_op_2' },
  { label: 'Usuário Consulta', value: 'usuario_consulta' }
]

const formatRealm = value => {
  const realm = REALMS.find(r => r.value === value)
  return realm ? realm.label : ''
}

const initialValues = {
  usuarioInativado: 'nao'
}

const UsuarioFilter = () => {
  const filter = useFilter({})
  const { push } = useHistory()
  useEffect(() => {
    const newParams = new URLSearchParams(initialValues)
    push(`/usuarios?${newParams}`)
  }, [push])

  return (
    <Filter
      {...filter}
      initialValues={initialValues}
      labels={{ find: 'Buscar', clear: 'Limpar' }}
    >
      <Grid container spacing={3}>
        <Grid item sm={8} xs={12}>
          <Usuario />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Field
            fullWidth
            name="realm"
            label="Cargo"
            component={CustomAutocomplete}
            options={REALMS}
            hideEmpty
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Field
            fullWidth
            name="codigoLotacao"
            label="Centro de custo"
            component={CentroCustoAutocomplete}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Field
            fullWidth
            name="unidadeNegocioId"
            label="Unidades de negócio"
            component={UnidadeNegocioAutocomplete}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Field
            fullWidth
            options={[
              { label: 'Sim', value: 'sim' },
              { label: 'Não', value: 'nao' }
            ]}
            initialValue="nao"
            defaultValue="nao"
            name="usuarioInativado"
            label="Usuário Inativado"
            component={CustomAutocomplete}
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

const Usuarios = ({ ...props }) => {
  const [ability] = useAbility()
  const listOptions = {
    defaultOrder: 'usuario',
    fields: {
      usuario: {
        label: 'Usuário'
      },
      realm: {
        label: 'Cargo',
        format: realm => formatRealm(realm)
      },
      lotacao: {
        label: 'Centro de Custo'
      },
      deletedAt: {
        label: 'Inativado em',
        format: data => data && moment(data).format('DD/MM/YYYY HH:mm')
      }
    }
  }

  const listHook = useListRepository({
    repository: UsuariosRepository,
    defaultSort: 'usuario',
    path: 'usuarios'
  })
  const actions = getListActions(ability, listHook, 'usuarios')

  return (
    <>
      <UsuarioFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickView={null}
        onClickNew={null}
        removeItem={listHook.removeItem}
        hideDownloadIcon
        listOptions={listOptions}
      />
    </>
  )
}

export default Usuarios
